

export const veoHero = {
    title: 'AI Video Generator',
    desc:
      'Experience cinema‑grade AI video creation. Control every frame with keyframe mode, extend scenes beyond 8 seconds, and generate synchronized native audio. Advanced models provide realistic motion generation, multi‑image reference control, and 1080P quality. From text or images to professional videos—start creating today.'
  };
